export default "__VITE_ASSET__0ac7da48__"